<mat-form-field
  class="search-container"
  [style.width]="`${Math.max(placeholder().length, 10) + 10}ch`"
  appearance="outline"
  floatLabel="always"
  subscriptSizing="dynamic"
>
  <mat-label>{{ 'common.search' | translate }}</mat-label>
  <input data-cy="search-input" matInput [placeholder]="placeholder() | translate" [formControl]="searchControl" />
  <mat-icon matPrefix>search</mat-icon>
  @if (searchControl.value) {
    <mat-icon (click)="clear()" matSuffix>close</mat-icon>
  }
</mat-form-field>
